import { useCallback } from 'react';

import { useFeature } from '@core/feature-toggles';
import { cn } from '@lib/utils';

import styles from './system-message.module.css';

export const useSystemMessage = () => {
  const { enabled: systemMessageEnabled, value: systemMessageValue } =
    useFeature('system-banner');

  const LowPriorityMessage = useCallback(
    () => (
      <div className={cn(styles.banner, styles.lowPriorityBanner)}>
        <span className={styles.bannerText}>{systemMessageValue?.message}</span>
      </div>
    ),
    [systemMessageValue?.message]
  );

  const HighPriorityMessage = useCallback(
    () => (
      <div className={cn(styles.banner, styles.highPriorityBanner)}>
        <span className={styles.bannerText}>{systemMessageValue?.message}</span>
      </div>
    ),
    [systemMessageValue?.message]
  );

  const getSystemMessage = useCallback(() => {
    if (systemMessageEnabled) {
      switch (systemMessageValue?.priority) {
        case 'high': {
          return <HighPriorityMessage />;
        }
        case 'low': {
          return <LowPriorityMessage />;
        }
      }
    }
  }, [
    HighPriorityMessage,
    LowPriorityMessage,
    systemMessageEnabled,
    systemMessageValue
  ]);

  return {
    getSystemMessage
  };
};
